module.exports = __webpack_public_path__ + "media/images/icon-solution-3f6b39a3e30253ffd6e15a32ba64d9c5.svg";